var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconActiveSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 18,
    fill: "#83CDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 27.743,
    x: 42.144,
    y: 10.5,
    fill: "#208C75",
    rx: 1.5,
    transform: "rotate(45 42.144 10.5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 19.504,
    x: 10.5,
    y: 18.762,
    fill: "#208C75",
    rx: 1.5,
    transform: "rotate(-45 10.5 18.762)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconActiveSucess);
export default __webpack_public_path__ + "static/media/icon_active_sucess.66a90a3f77b65e871ff1f168ba74e461.svg";
export { ForwardRef as ReactComponent };